module.exports = __webpack_public_path__ + "static/media/49.07b33821.jpeg";